export type LogoVariant = 'light' | 'dark';
export type ThemeMode = 'light' | 'dark';

export const LogoVariants = {
    Light: 'light' as LogoVariant,
    Dark: 'dark' as LogoVariant,
} as const;

export const ThemeModes = {
    Light: 'light' as ThemeMode,
    Dark: 'dark' as ThemeMode,
} as const;

export const DEFAULT_BRANDING_COLORS = {
    primaryColor: '#0b8580',
    secondaryColor: '#6c757d',
    successColor: '#198754',
    infoColor: '#0dcaf0',
    warningColor: '#ffc107',
    dangerColor: '#dc3545',
} as const;

export const LOGO_VALIDATION = {
    maxSizeBytes: 1_048_576,
    acceptedTypes: ['image/png', 'image/svg+xml'] as readonly string[],
    acceptAttribute: '.png,.svg,image/png,image/svg+xml',
} as const;
